import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import roles from "../features/admin/role_permmission/role/Slice";
import employee from "../features/admin/role_permmission/employee/Slice";



const customers = combineReducers({
    roles: roles,
    employee: employee,
  
  });
  
  export default customers;